<div class="card-container h-100" style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #ffffff;">
  <div class="card-header py-2 px-3 text-white font-weight-bold" style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-wallet mr-1"></i> Income & Expenses Details
  </div>

  <div class="p-3" *ngIf="!incomeData || incomeData.length === 0">
    <div class="text-center p-3 bg-light rounded text-muted font-size-12">
      <i class="fas fa-info-circle mr-1"></i> No Income/Expense Information Available!
    </div>
  </div>

  <div class="cnt-data p-3" *ngIf="incomeData && incomeData.length > 0">
    <!-- Income Section -->
    <div class="income mb-3">
      <div class="small font-weight-bold text-success text-uppercase mb-2" style="font-size: 0.75rem; letter-spacing: 0.5px;">
        <i class="fas fa-arrow-circle-down mr-1"></i> Income Details
      </div>
      <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
        <div *ngFor="let item of incomeData">
          <div class="p-2.5 rounded border" style="background: rgba(16, 185, 129, 0.06); border-color: rgba(16, 185, 129, 0.2) !important;" *ngIf="item['Type'] == 'Income'">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item["Nature"] }}</div>
                <div class="text-muted small" style="font-size: 0.75rem;">Source: {{ item["Institution_From"] }}</div>
              </div>
              <div class="text-right">
                <div class="font-weight-bold text-success" style="font-size: 0.9375rem;">+ ₹{{ item["Amount"] }}</div>
                <a target="_blank" *ngIf="item.Doc_FileName" [href]="income + item['Customer_Id'] + '/' + item['Doc_FileName']" class="btn btn-sm btn-outline-success py-0 px-1 mt-1 font-size-11">
                  <i class="fas fa-paperclip mr-1"></i> Attachment
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Expense Section -->
    <div class="expense">
      <div class="small font-weight-bold text-danger text-uppercase mb-2" style="font-size: 0.75rem; letter-spacing: 0.5px;">
        <i class="fas fa-arrow-circle-up mr-1"></i> Expenses Details
      </div>
      <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
        <div *ngFor="let item of incomeData">
          <div class="p-2.5 rounded border" style="background: rgba(239, 68, 68, 0.06); border-color: rgba(239, 68, 68, 0.2) !important;" *ngIf="item['Type'] == 'Expense'">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item["Nature"] }}</div>
                <div class="text-muted small" style="font-size: 0.75rem;">Type: {{ item["Institution_From"] }}</div>
              </div>
              <div class="text-right">
                <div class="font-weight-bold text-danger" style="font-size: 0.9375rem;">- ₹{{ item["Amount"] }}</div>
                <a target="_blank" *ngIf="item.Doc_FileName" [href]="income + item['Customer_Id'] + '/' + item['Doc_FileName']" class="btn btn-sm btn-outline-danger py-0 px-1 mt-1 font-size-11">
                  <i class="fas fa-paperclip mr-1"></i> Attachment
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>